// extracted by mini-css-extract-plugin
export default {"messageSearch":"styles_messageSearch__-SmwW"};